module.exports = __webpack_public_path__ + "img/003.ae338a1e.jpg";